const routeVariants = {
    initial: {
        opacity: 0,
        y: "100px",
    },
    final: {
        opacity: 1,
        y: "0px",
        transition: {
            duration: 0.4,
            delay: 0.4,
           
        },
    },
}

export const routeVariantsRight = {
    initial: {
        opacity: 0,
        x: "200px",
    },
    final: {
        opacity: 1,
        x: "0px",
        transition: {
            duration: 0.3,
            delay: 0.3,
           
        },
    },
}

export default routeVariants
